<script setup lang="ts">
  import { marked } from 'marked'

  const props = defineProps<{
    blok: any
  }>()

  const output = computed(() => marked(props.blok.content))
</script>

<template>
  <div
    class="text-lead [&_a]:text-inherit"
    v-html="output"
  />
</template>
